import { Card as MuiCard, CardProps as MuiCardProps } from '@material-ui/core'

export type CardProps = MuiCardProps

export default function Card(props: CardProps) {
  return <MuiCard {...props} />
}
